import { UserService } from '../../../shared/services';
import { UserNewComponent } from '../user-new/user-new.component';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTable, DataTableParams, DataTableTranslations } from 'angular-datatables-all-versions';
import { ToastyService } from 'ng2-toasty';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { UserDataSource } from './user.datasource';
import { IPagination, IUser } from '../../../shared/models/ipagination.model';
import { User } from '../../../shared/models';
import { AssociationService } from 'app/shared/services/association.service';
import { Association } from 'app/shared/models/association.model';
import { LoaderService } from 'app/shared/services/loader.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit, AfterViewInit {
  @ViewChild('search_input', { static: true }) searchInputRef: ElementRef;
  @ViewChild('search_btn', { static: false }) searchBtnRef: ElementRef;
  @ViewChild(DataTable, { static: false }) userTable: DataTable;

  users: IUser[];
  dataSource: UserDataSource;
  userCount = 0;
  limits = [25, 50, 100];

  associations: Association[];
  selectedAssoc: Association;
  assocLabel: string;
  routeParams: DataTableParams;

  public userType = '';

  translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Infos.',
    selectColumn: 'Sélectionner',
    paginationLimit: 'Max.',
    paginationText: 'Résultats: {from} - {to} / {total}',
    paginationTotalPages: '/'
  }

  constructor(private toastyService: ToastyService, private service: UserService, private modalService: NgbModal,
    private changeDetector: ChangeDetectorRef, private associationService: AssociationService,
    private loaderService: LoaderService, private route: ActivatedRoute, private router: Router,) {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
    this.userType = this.route.snapshot.paramMap.get('type');
    this.dataSource = new UserDataSource(service, loaderService);
    this.associationService.unFilteredList().subscribe(data => {
      this.associations = data;
    });
  }

  ngOnInit() {
    this.dataSource.load(null, null, null, null, null, this.userType);
    this.dataSource.pagination.subscribe(
      (data: IPagination) => {
        if (data && data.hasOwnProperty('meta')) {
          this.userCount = data.meta.pagination.total_objects;
          this.users = data.users;
        }
      });
  }

  ngAfterViewInit(): void {
    fromEvent(this.searchBtnRef.nativeElement, 'click').pipe(debounceTime(100), distinctUntilChanged(),
      tap(() => {
        this.changeDetector.detectChanges();
        this.userTable.offset = 1;

        this.loadUsersPage();
      })).subscribe(() => {
        this.dataSource.pagination.subscribe(
          data => {
            this.changeDetector.detectChanges();
          });
      });
  }

  reload(_params: DataTableParams) {
    this.routeParams = _params;
    this.loadUsersPage();
  }

  onBanUser(user: IUser) {
    this.service.enableOrDesableUser(Object.assign(new User(), user)).subscribe(
      data => {
        this.loadUsersPage();
        // notify user
        const verb = data.is_active ? 'activ&eacute;e' : 'desactiv&eacute;e';
        this.toastyService.success({
          title: 'Success',
          msg: 'Utilisateur ' + verb,
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      },
      () => this.toastyService.error({
        title: 'Attention',
        msg: 'Une erreur s\'est produite, reessayer plus tard',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      }));
  }

  cellColor(car) {
    return 'rgb(255, 255,' + (155 + Math.floor(100 - ((car.rating - 8.7) / 1.3) * 100)) + ')';
  }

  onCreateUser() {
    const modalRef = this.modalService.open(UserNewComponent);
    modalRef.result.then((result) => {
      if ('user-modal-success' === result) {
        this.loadUsersPage();
        this.toastyService.success({
          title: 'Success',
          msg: 'Manager cr&eacute&eacute',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        })
      }
    }, () => console.log());
  }

  onExportData() {

    if (!this.assocLabel || this.assocLabel === '') {
      this.service.find({ offset: 1, limit: 99999, search: this.searchInputRef.nativeElement.value } as DataTableParams).subscribe(
        (data: IPagination) => {
          const exportdata: any[] = [];
          data.users.forEach(item => {
            exportdata.push({
              'Prénom': item.firstname,
              'Nom': item.name,
              'Adresse e-mail': item.email,
              'Phone': item.phone ? item.phone : '',
              'Role': item.role.name.toUpperCase(),
              /*               'Mangopay ID': item.mangopay_user_id ? item.mangopay_user_id : 'N/A',
                            'Mangopay Wallet': item.mangopay_wallet_id ? item.mangopay_wallet_id : 'N/A', */
              'Pays': item.user_adress ? item.user_adress.country_iso : 'N/A',
              'Nombre dons': item.pots_count,
              'Nombre participations': item.participations_count,
            });
          });
          this.downloadCsv(exportdata);
        });
    }
    else {
      this.service.find({ offset: 1, limit: 99999, search_assoc: this.selectedAssoc.id.toString() } as DataTableParams).subscribe(
        (data: IPagination) => {
          const exportdata: any[] = [];
          data.users.forEach(item => {
            exportdata.push({
              'Prénom': item.firstname,
              'Nom': item.name,
              'Adresse e-mail': item.email,
              'Phone': item.phone ? item.phone : '',
              'Role': item.role.name.toUpperCase(),
              /*               'Mangopay ID': item.mangopay_user_id ? item.mangopay_user_id : 'N/A',
                            'Mangopay Wallet': item.mangopay_wallet_id ? item.mangopay_wallet_id : 'N/A', */
              'Pays': item.user_adress ? item.user_adress.country_iso : 'N/A',
              'Nombre dons': item.pots_count,
              'Nombre participations': item.participations_count,
            });
          });
          this.downloadCsv(exportdata);
        });
    }
  }

  downloadCsv(exportdata) {
    const csvData = this.convertToCSV(exportdata);
    const blob = new Blob([csvData], { type: 'text/csv' });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, 'users.csv');
    } else {
      const a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = 'users.csv';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  searchByAssociation() {
    const offset = this.routeParams.offset / this.routeParams.limit;
    // tslint:disable-next-line: curly
    if (this.assocLabel === '')
      this.dataSource.load(this.searchInputRef.nativeElement.value, offset + 1, this.routeParams.limit, null, null, this.userType);
    // tslint:disable-next-line: curly
    else
      this.dataSource.load(null, offset + 1, this.routeParams.limit, null, this.selectedAssoc.id.toString(), this.userType);
  }

  select(opt: Association) {
    this.selectedAssoc = opt;
  }

  private loadUsersPage() {
    const offset = this.routeParams.offset / this.routeParams.limit;
    this.dataSource.load(this.searchInputRef.nativeElement.value, offset + 1, this.routeParams.limit, null, null, this.userType);
  }

  private convertToCSV(objArray) {
    const replacer = (_key, value) => value === null ? '' : value
    const header = Object.keys(objArray[0])
    let csv = objArray.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(';'))
    csv.unshift(header.join(';'));
    csv = csv.join('\r\n')
    return csv;
  }
}
